import React, { useEffect, useState, useRef }                                   from 'react';
import { useHistory }                                                           from 'react-router';
import { Tab, Nav, Tabs, TabContainer, Fade, Button, Alert }                    from 'react-bootstrap';
import { useDispatch, useSelector }                                             from 'react-redux';
import Select                                                                   from 'react-select';
import Swal                                                                     from 'sweetalert2';

import clienteAxios                                                             from '../../config/axios';
import axiosProceedings                                                         from '../../config/axiosProceeding';

import { ErrorMessage, WaitingMessage, SuccessMessage }                         from '../../components/extras/toastMessages';
import { ICON_SEARCH, ICON_REMOVE, ICON_NEXT, ICON_PREV, ICON_SAVE, ICON_NEW }  from '../extras/icons';
import { FISCALIA }                                                             from '../../data/jurisdictions';
import { FUNC_FISCAL }                                                          from '../../data/functionaryTypes';
import { saveAudiencesAction }                                                  from '../../actions/audiencesActions';
import { v4 as uuidv4 }                                                         from 'uuid';

import AccusedFormModal                                                         from './form/AccusedFormModal';
import AccusedInfoForm                                                          from './form/AccusedInfoForm';
import AudienceService                                                          from '../../services/AudienceService';
import DrawRules                                                                from '../extras/DrawRules';
import InterveningFormModal                                                     from './form/InterveningFormModal';
import InterveeningInfoForm                                                     from './form/InterveeningInfoForm';
import LawyerSearchForm                                                         from './LawyerSearchForm';
import ProceedingParts                                                          from './form/ProceedingParts';
import ProceedingResults                                                        from './form/ProceedingResults';
import VictimFormModal                                                          from './form/VictimFormModal';
import VictimInfoForm                                                           from './form/VictimInfoForm';





const AudienceForm = () => {



    // --------------------------------------------------------------------------------------------
    // DECLARACIONES ------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Genero los refs
    const refNumero = useRef();

    // Constantes iniciales de datos
    const initialFile = {
        number: '',
        date: '',
        cover: ''
    }

    // Inicializo el history
    const history = useHistory();

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Inicializo el state local
    const [accuseds, setAccuseds] = useState([]);
    const [audienceTypes, setAudienceTypes] = useState([]);
    const [characters, setCharacters] = useState([]);
    const [defensories, setDefensories] = useState([]);
    const [dependencies, setDependencies] = useState([]);
    const [file, setFile] = useState(initialFile);
    const [intervenings, setIntervenings] = useState([]);
    const [key, setKey] = useState(1);
    const [loading, setLoading] = useState(false);
    const [localidades, setLocalidades] = useState([]);
    const [minors, setMinors] = useState([]);    
    const [partType, setPartType] = useState('accused'); //Por defecto es acusado
    const [proceedings, setProceedings] = useState([]);
    const [prosecutorOficces, setProsecutorOficces] = useState([]);
    const [prosecutors, setProsecutors] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [selectedAccused, setSelectedAccused] = useState(null);
    const [selectedProceeding, setSelectedProceeding] = useState(null);
    const [selectedVictim, setSelectedVictim] = useState(null);
    const [showAccusedForm, setShowAccusedForm] = useState(false);
    const [showInterveningForm, setShowInterveningForm] = useState(false);
    const [showLawyer, setShowLayer] = useState(false);
    const [showProceedingParts, setShowProceedingParts] = useState(false);
    const [showProceedingResult, setShowProceedingResult] = useState(false);
    const [showVictimForm, setShowVictimForm] = useState(false);
    const [victims, setVictims] = useState([]);   

    const [audience, setAudience] = useState({        
        caratula: '',
        codbar_origen: '',
        dj: '',
        fecha_hecho: '',
        fiscal: '',
        fiscalia: '',
        id_origen: '',
        imputados: [],
        intervinientes: [],
        numero: '',
        observacion: '',
        tiposDeAudiencia: [],
        vencimiento_ipp: '',
        victimas: [],
    });
    const [steps, setSteps] = useState({
        p1: 'active',
        p2: '',
        p3: '',
        p4: '',
        p5: ''
    });



    // --------------------------------------------------------------------------------------------
    // FUNCIONES ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Cargo los parámetros al inicio
    useEffect(() => {
        loadParameters();
        //eslint-disable-next-line
    }, []);

    // Manejo la carga de parámetros
    const loadParameters = async () => {
        try
        {   //Cargo la espera
            WaitingMessage('Cargando parámetros');
            //Tipos de audiencia
            const responseTipo = await clienteAxios.get(`/audiencia-tipo?search=activo:1&sort=descripcion:asc`);
            setAudienceTypes(responseTipo.data.content);
            //Fiscalia
            const responseProsecutorOffices = await clienteAxios.get(`/unidad?search=perfil.id:${FISCALIA},activo:1&sort=descripcion:asc`);
            setProsecutorOficces(responseProsecutorOffices.data.content);
            //Fiscales
            const responseProsecutors = await clienteAxios.get(`/funcionario?search=tipo.id:${FUNC_FISCAL},activo:1&sort=apellido:asc&sort=nombre:asc`);
            setProsecutors(responseProsecutors.data.content);
            //Defensoría de Menores
            const responseMinors = await clienteAxios.get(`/defensoria?search=menor:1,activo:1&sort=descripcion:asc`);
            setMinors(responseMinors.data.content);
            //Defensorias
            const responseDefensories = await clienteAxios.get(`/defensoria?search=activo:1&sort=descripcion:asc`);
            setDefensories(responseDefensories.data.content);
            //Dependencias
            const responseDependencies = await clienteAxios.get(`/dependencia?search=activo:1&sort=descripcion:asc`);
            setDependencies(responseDependencies.data.content);
            //Caracteres
            const responseCharacters = await clienteAxios.get(`/caracter?search=activo:1&sort=descripcion:asc`);
            setCharacters(responseCharacters.data.content);
            //Oculto la espera
            Swal.close();
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }

    // Manejo agregar intervinientes
    const handleAddIntervening = () => {
        setIntervenings([
            ...intervenings,
            {   id: uuidv4(),
                name: 'Nombre'
            }
        ])
    }

    // Manejo el cambio
    const handleChange = e => {
        if( e.target.name==='tiposDeAudiencia' )
        {   var options = e.target.options;

            var value = [];
            for(var i = 0, l = options.length; i < l; i++)
            {   if(options[i].selected)
                {   value.push(options[i].value);
                }
            };
            //Seteo los datos
            setAudience({
                ...audience,
                [e.target.name]: value
            })
        }
        else
        {   //Seteo los datos
            setAudience({
                ...audience,
                [e.target.name]: e.target.value
            })
        }
    }
    // Manejo cambio del select
    const handleChangeAudienceType = options => {
        //Seteo los datos
        setAudience({
            ...audience,
            tiposDeAudiencia: options ? options.map( option=>(
                {   id: option.value
                }
            )) : []
        })
    }

    // Manejo ocultar acusado
    const handleCloseAF = () => {
        //Oculto
        setShowAccusedForm(false);
        //Limpio los datos
        setSelectedAccused(null);
    }
    // Manejo ocultar interviniente
    const handleCloseIF = () => {
        setShowInterveningForm(false);
    }
    // Manejo ocultar abogado
    const handleCloseLawyerSearch = () => {
        setShowLayer(false);
    }
    // Manejo el cierre de partes
    const handleCloseProceedingParts = () => {
        setShowProceedingParts(false);
    }
    // Manejo ocultar victima
    const handleCloseVF = () => {
        //Oculto
        setShowVictimForm(false);
        //Limpio los datos
        setSelectedVictim(null);
    }

    // Manejo el editar imputado
    const handleEditAccused = item => {
        //Seteo el imputado a editar
        setSelectedAccused(item);
        //Muestro el dialogo
        handleOpenAF();
    }
    // Manejo el editar victima
    const handleEditVictim = item => {
        //Seteo la victima a editar
        setSelectedVictim(item);
        //Muestro el dialogo
        handleOpenVF();
    }

    // Manejo mostrar acusado
    const handleOpenAF = () => {
        setShowAccusedForm(true);
    }
    // Manejo mostrar interviniente
    const handleOpenIF = () => {
        setShowInterveningForm(true);
    }
    // Manejo mostrar abogado
    const handleOpenLawyerSearch = () => {
        setShowLayer(true);
    }
    // Manejo apertura de partes
    const handleOpenProceedingParts = type => {
        //Me fijo si hay expediente seleccionad
        if(selectedProceeding)
        {   //Seteo
            setPartType(type);
            //Abro
            setShowProceedingParts(true);
        }
        else
        {   ErrorMessage('No hay Legajo seleccionado');
        }
    }
    // Manejo mostrar victima
    const handleOpenVF = () => {
        setShowVictimForm(true);
    }

    // Manejo el eliminar imputado
    const handleRemoveAccused = item => {
        //Seteo datos
        setAccuseds([
            ...accuseds.filter(accused => accused.index !== item.index)
        ]);
    }
    // Manejo el eliminar interviniente
    const handleRemoveIntervening = item => {
        setIntervenings([
            ...intervenings.filter(intervening => intervening.index !== item.index)
        ]);
    }
    // Manejo el limpiado de expediente
    const handleRemoveProceeding = () => {
        //Remuevo la selección del expediente
        setSelectedProceeding(null);
        //Tengo que limpiar datos del expediente
        setAudience({
            ...audience,
            numero: '',
            fecha_hecho: '',
            caratula: '',
            id_origen: '',
            codbar_origen: ''
        });
        //Pongo el foco
        refNumero.current.focus();
    }
    // Manejo el eliminar victima
    const handleRemoveVictim = item => {
        //Seteo la victima
        setVictims([
            ...victims.filter(victim => victim.index !== item.index)
        ]);
    }
    
    // Función de buscar expedientes
    const handleSearchProceeding = async e => {
        e.preventDefault();
        //Me fijo que haya ingresado nro de legajo
        if(!audience.numero || audience.numero.trim() === '')
        {   ErrorMessage('Debe indicar el número de Legajo');
            refNumero.current.focus();
            return false;
        }
        //Hago la búsqueda
        try
        {   //Cargo la espera
            WaitingMessage('Buscando legajo');
            //Armo los datos
            const params = {
                legajo: audience.numero
            }
            //Consulta expediente
            const response = await axiosProceedings.get(`/proceso`, { params });
            const res = response.data;
            //Tomo los datos de expedientes
            const resProceedings = res.expedientesList;
            const resProceedingsStatus = res.statusList;
            //Agrego los datos
            setProceedings(resProceedings);
            //Oculto la espera
            Swal.close();
            //Genero queue de mensajes
            let resProceedingsAlerts = [];
            //Me fijo si hay datos
            if(resProceedings.length > 0)
            {   //Pongo timer por transición de ventanas
                setTimeout(() => {
                    setShowProceedingResult(true);
                }, 500);
            }            
            // Muestro status de servicios que devuelven error
            if(resProceedingsStatus.length > 0)
            {   resProceedingsStatus.map( (pstatus,index)=>{
                    //Verifico respuesta
                    if(pstatus.code !== 200 && pstatus.code !== 404){
                        resProceedingsAlerts.push(
                        {   title: `Error al conectarse a ${pstatus.serviceUrl}`,
                            text: pstatus.message,  
                            icon: 'error'
                        }
                    )}                    
                });
            }            
            Swal.queue(resProceedingsAlerts).then(()=>{
                if(resProceedings.length == 0)
                    ErrorMessage('No se encontraron Legajos con el número indicado!!!');
            });
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }

    // Manejo la selección
    const handleSelect = k => {
        //Inicializo valida
        let validated = false;
        //Si el paso aumenta, debo validar
        if(k > key)
        {   //Verifico la validación
            if(!handleValidation(k))
            {   return false;
            }
            //Seteo
            validated = true;
        }
        //Seteo la clase
        setSteps({
            ...steps,
            [`p${key}`]: validated ? 'done' : '',
            [`p${k}`]: 'active'
        });
        //Seteo la key
        setKey(k);
    } 

    // Manejo el submit
    const handleSubmit = e => {
        e.preventDefault();
        //Tengo que hacer todas las validaciones
        if(!handleValidationFirstStep())
        {   return false;
        }
        if(!handleValidationSecondStep())
        {   return false;
        }
        if(!handleValidationThirdStep())
        {   return false;
        }
        if(!handleValidationFourStep())
        {   return false;
        }
        if(!handleValidationFiveStep())
        {   return false;
        }
        //Armos los datos
        let data = {
            numero: audience.numero,
            caratula: audience.caratula,
            id_origen: audience.id_origen,
            codbar_origen: audience.codbar_origen,
            fecha_hecho: audience.fecha_hecho,
            fiscalia: {
                id: audience.fiscalia
            },
            fiscal: {
                id: audience.fiscal
            },
            observacion: audience.observacion,
            solicitante: null,
            dj: audience.dj,
            vencimientoIPP: audience.vencimiento_ipp
        }
        data = {
            ...data,
            tiposDeAudiencia: audience.tiposDeAudiencia,
            imputados: accuseds,
            victimas: victims,
            intervinientes: intervenings
        }
        //Llamo al dispatch
        dispatch( saveAudiencesAction(data, history) );
    }
    // Manejo el cierre de resultados
    const handleCloseProceedingResult = () => {
        setShowProceedingResult(false);
    }
    // Función para buscar expedientes
    const handleKeyProceedingNumber = e => {
        //Tiene que ser Enter
        if(e.charCode === 13)
        {   //Ejecuto búsqueda
            handleSearchProceeding(e);
        }
    }
    
    // Manejo la validación de cada paso
    const handleValidation = k => {
        switch(k) {
            case 1:
                return true;
            case 2:
                return handleValidationFirstStep();
            case 3:
                return handleValidationSecondStep();
            case 4:
                return handleValidationThirdStep();
            case 5:
                return handleValidationFourStep();
        }
    }
    // Validación de paso 1
    const handleValidationFirstStep = () => {
        //Expediente
        if(!audience.numero || audience.numero.trim() === '')
        {   //Envío mensaje
            ErrorMessage('Debe indicar el Nro de Expediente');
            //Retorno
            return false;
        }
        //Fecha hecho
        if(!audience.fecha_hecho || audience.fecha_hecho.trim() === '')
        {   //Envío mensaje
            ErrorMessage('Debe indicar la Fecha del Hecho');
            //Retorno
            return false;
        }
        //Caratula
        if(!audience.caratula || audience.caratula.trim() === '')
        {   //Envío mensaje
            ErrorMessage('Debe indicar la carátula');
            //Retorno
            return false;
        }
        //Retorno
        return true;
    }
    // Validaación de paso 2
    const handleValidationSecondStep = () => {
        //Tipos de Audiencia
        if(!audience.tiposDeAudiencia || audience.tiposDeAudiencia.length === 0)
        {   //Envío mensjae
            ErrorMessage('Debe seleccionar al menos un Tipo de Audiencia');
            //Retorno
            return false;
        }
        //Fiscalia
        if(!audience.fiscalia || audience.fiscalia === '')
        {   //Envío mensjae
            ErrorMessage('Debe indicar la Fiscalía');
            //Retorno
            return false;
        }
        //Fiscal
        if(!audience.fiscal || audience.fiscal === '')
        {   //Envío mensjae
            ErrorMessage('Debe indicar el Fiscal');
            //Retorno
            return false;
        }
        //Retorno
        return true;
    }
    // Validación de paso 3
    const handleValidationThirdStep = () => {
        //Me tengo que fijar que tenga imputados
        if(accuseds.length === 0)
        {   //Debe cargar los datos del imputado
            ErrorMessage('Debe indicar al menos un Imputado');
            //Retorno
            return false;
        }
        else
        {   let resValidation = true;
            //Verifico los datos de cada imputado
            accuseds.map( accused=>{
                //Valido
                resValidation = AudienceService.isAccusedValid(accused);
                //Verifico
                if(!resValidation)
                {   //Muestro mensaje
                    ErrorMessage('Debe completar todos los datos obligatorios de los Imputados');
                    //Corto
                    return false;
                }
            })
            //Retorno resultado
            return resValidation;
        }
        //Retorno
        return true;
    }
    // Validación de paso 4
    const handleValidationFourStep = () => {
        //Me tengo que fijar que tenga víctimas
        if(victims.length > 0)
        {   let resValidation = true;
            //Verifico los datos de cada víctima
            victims.map( victim=>{
                //Valido
                resValidation = AudienceService.isVictimValid(victim);
                //Verifico
                if(!resValidation){
                    //Muestro mensaje
                    ErrorMessage('Debe completar todos los datos obligatorios de las Víctimas');
                    //Corto
                    return false;
                }
            })
            //Retorno resultado
            return resValidation;
        }
        //Retorno
        return true;
    }
    // Validación de paso 5
    const handleValidationFiveStep = () => {
        //Tengo que validar el campo de DJ
        if(audience.dj == '' || isNaN(audience.dj) || parseInt(audience.dj) != 1)
        {   //Si no está seteado, no dejo continuar
            ErrorMessage('Debe aceptar la condición de Declaración Jurada de los datos enviados');
            //Retorno
            return false;
        }
        //Retorno
        return true;
    }
    


    // --------------------------------------------------------------------------------------------
    // RENDERIZO ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    return (
        <React.Fragment>
            <div className="row">

                <div className="col-12">
                    <DrawRules />
                </div>

                <div className="col-12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h6 className="m-0 font-weight-bold text-primary">Nueva Solicitud</h6>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit} autoComplete="off">
                                <div id="smartwizard" className="sw-main sw-theme-default">
                                <Tab.Container 
                                    className = "sw-main sw-theme-default" 
                                    transition = { Fade }
                                    activeKey = { `p${key}` }
                                    onSelect = { handleSelect }
                                >
                                    <Nav className="step-anchor" as="ul">
                                        <Nav.Item className={`nav-item ${steps.p1}`}  as="li">
                                            <Nav.Link className="nav-link" onClick={ ()=>handleSelect(1) } >
                                                Paso 1
                                                <br />
                                                <small>Datos del Legajo</small>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className={`nav-item ${steps.p2}`} as="li">
                                            <Nav.Link onClick={ ()=>handleSelect(2) } >
                                                Paso 2
                                                <br />
                                                <small>Datos de la Audiencia</small>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className={`nav-item ${steps.p3}`} as="li">
                                            <Nav.Link onClick={ ()=>handleSelect(3) } >
                                                Paso 3
                                                <br />
                                                <small>Datos del Imputado</small>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className={`nav-item ${steps.p4}`} as="li">
                                            <Nav.Link onClick={ ()=>handleSelect(4) } >
                                                Paso 4
                                                <br />
                                                <small>Datos de la Víctima</small>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className={`nav-item ${steps.p5}`} as="li">
                                            <Nav.Link onClick={ ()=>handleSelect(5) } >
                                                Paso 5
                                                <br />
                                                <small>Otros intervinientes</small>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                    <Tab.Content>

                                        { /* PASO 1 */ }
                                        <Tab.Pane eventKey="p1" transition={Fade}>
                                            <div className="row my-4 mx-2">
                                                <div className="col-12">
                                                    <div className="alert alert-info">
                                                    Ingrese el nro. de Legajo y presione <strong>ENTER</strong> para buscar los datos. Si el resultado obtenido es el deseado, presione en el tilde verde para aceptar. En caso de no encontrar resultados puede ingresarlos de forma manual en los campos correspondientes. <strong>UTILICE SIEMPRE 4 DIGITOS PARA EL AÑO EN EL NRO. DE LEGAJO.</strong>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 form-group">
                                                    <input 
                                                        type = "text"
                                                        className = "form-control"
                                                        placeholder = "Nro. de Legajo"
                                                        name = "numero"
                                                        onChange = { handleChange }
                                                        value = { audience.numero }
                                                        ref = { refNumero }
                                                        onKeyPress = { handleKeyProceedingNumber }
                                                        readOnly = { selectedProceeding }
                                                        autoFocus
                                                    />
                                                </div>
                                                <div className="col-md-1 form-group">
                                                    <Button variant="primary" block type="button" onClick={handleSearchProceeding}>
                                                        <ICON_SEARCH />
                                                    </Button>
                                                    <ProceedingResults
                                                        show = { showProceedingResult }
                                                        handleClose = { handleCloseProceedingResult }
                                                        audience = { audience }
                                                        proceedings = { proceedings }
                                                        handleSelect = { setSelectedProceeding }
                                                        setData = { setAudience }
                                                    />
                                                </div>
                                                <div className="col-md-2 form-group">
                                                    <input 
                                                        type = "date"
                                                        className = "form-control"
                                                        placeholder = "Fecha hecho"
                                                        name = "fecha_hecho"
                                                        onChange = { handleChange }
                                                        value = { audience.fecha_hecho }
                                                    />
                                                </div>
                                                <div className="col-md-11 form-group">
                                                    <input 
                                                        type = "text"
                                                        className = "form-control"
                                                        placeholder = "Datos de la carátula"
                                                        name = "caratula"
                                                        onChange = { handleChange }
                                                        value = { audience.caratula }
                                                        readOnly = { selectedProceeding }
                                                    />
                                                </div>
                                                <div className="col-md-1 form-group">
                                                    <Button variant="danger" block onClick={handleRemoveProceeding}>
                                                        <ICON_REMOVE />
                                                    </Button>
                                                </div>
                                                <div className="col-12">
                                                    <Alert variant="secondary">
                                                        <Button className="float-right" variant="light" onClick={() => handleSelect(2)}>
                                                            <strong>SIGUIENTE PASO</strong>
                                                            &nbsp;
                                                            <ICON_NEXT />
                                                        </Button>
                                                        <div className="clearfix"></div>
                                                    </Alert>
                                                </div>
                                            </div>                                            
                                        </Tab.Pane>


                                        { /* PASO 2 */ }
                                        <Tab.Pane eventKey="p2" transition={Fade}>
                                            <div className="row my-4 mx-2">
                                                <div className="col-12">
                                                    <div className="alert alert-info">
                                                    Indique el/los <strong>tipo/s de audiencia</strong> que corresponda/n. Luego seleccione la <strong>Unidad Fiscal</strong>, el <strong>Fiscal</strong> que participará en la misma y la <strong>Fecha de Vencimiento de IPP</strong>.
                                                    </div>
                                                </div>
                                                <div className="col-md-12 form-group">
                                                    <Select
                                                        isMulti
                                                        name = "tiposDeAudiencia"                                                        
                                                        noOptionsMessage = { ()=>("No se encontraron datos") }
                                                        onChange = { handleChangeAudienceType }
                                                        placeholder = "Seleccione el/los Tipo/s de Audiencia"
                                                        options = {
                                                            audienceTypes 
                                                                ?
                                                                    audienceTypes.map( audienceType=>(
                                                                        {   value: audienceType.id,
                                                                            label: audienceType.descripcion
                                                                        }
                                                                    ))
                                                                : 
                                                                    []
                                                        }
                                                    />
                                                </div>
                                                <div className="col-md-4 form-group">
                                                    <select 
                                                        className = "form-control"
                                                        name = "fiscalia" 
                                                        onChange = { handleChange }
                                                    >
                                                        <option value="">Seleccione la Unidad Fiscal</option>
                                                        {   prosecutorOficces 
                                                                ?
                                                                    prosecutorOficces.map( prosecutorOficce=>(
                                                                        <option value={ prosecutorOficce.id } key={`afpo${prosecutorOficce.id}`}>
                                                                            { prosecutorOficce.descripcion }
                                                                        </option>
                                                                    ))
                                                                : 
                                                                    null
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-4 form-group">
                                                    <select 
                                                        className = "form-control"
                                                        name = "fiscal" 
                                                        onChange = { handleChange }
                                                    >
                                                        <option value="">Seleccione el Fiscal / Fiscal Auxiliar</option>
                                                        {   prosecutors 
                                                                ?
                                                                    prosecutors.map( prosecutor=>(
                                                                        <option value={prosecutor.id} key={`afp${prosecutor.id}`}>
                                                                            { `${prosecutor.apellido}, ${prosecutor.nombre}` }
                                                                        </option>
                                                                    ))
                                                                : 
                                                                    null
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-4 form-group">
                                                    <input 
                                                        className = "form-control"                                                        
                                                        name = "vencimiento_ipp"
                                                        onChange = { handleChange }
                                                        placeholder = "Vencimiento de IPP"                                                        
                                                        type = "date"
                                                        value = { audience.vencimiento_ipp }
                                                    />
                                                </div>
                                                <div className="col-12">
                                                    <Alert variant="secondary">
                                                        <Button className="float-left" variant="light" onClick={() => handleSelect(1)}>
                                                            <ICON_PREV />
                                                            &nbsp;
                                                            <strong>PASO ANTERIOR</strong>
                                                        </Button>
                                                        <Button className="float-right" variant="light" onClick={() => handleSelect(3)}>
                                                            <strong>SIGUIENTE PASO</strong>
                                                            &nbsp;
                                                            <ICON_NEXT />
                                                        </Button>
                                                        <div className="clearfix"></div>
                                                    </Alert>
                                                </div>
                                            </div>
                                        </Tab.Pane>


                                        { /* PASO 3 */ }
                                        <Tab.Pane eventKey="p3" transition={Fade}>
                                            <div className="row my-4 mx-2">
                                                <div className="col-12">
                                                    <div className="alert alert-info">
                                                        Si desea buscar datos de las partes del Legajo indicado, presione <ICON_SEARCH /> <strong>BUSCAR IMPUTADOS EN LAS PARTES DEL LEGAJO</strong>. Caso contrario presione el botón <ICON_NEW /> <strong>AGREGAR DATOS DE IMPUTADO</strong>
                                                    </div>
                                                </div>
                                                {   selectedProceeding 
                                                        ? 
                                                            <div className="col-md-6 form-group">
                                                                <Button variant="info" block onClick={() => handleOpenProceedingParts('accused')}>
                                                                    <ICON_SEARCH />
                                                                    &nbsp;
                                                                    <strong>BUSCAR IMPUTADOS EN LAS PARTES DEL LEGAJO</strong>
                                                                </Button>
                                                                <ProceedingParts
                                                                    show = { showProceedingParts }
                                                                    handleClose = { handleCloseProceedingParts }
                                                                    proceeding = { selectedProceeding }
                                                                    accuseds = { accuseds }
                                                                    setAccuseds = { setAccuseds }
                                                                    victims = { victims }
                                                                    setVictims = { setVictims }
                                                                    partType = { partType }
                                                                    editAccused = { handleEditAccused }
                                                                    editVictim = { handleEditVictim }
                                                                />
                                                            </div>
                                                        : 
                                                            null
                                                }
                                                <div className="col-md-4 form-group">
                                                    <Button variant="success" block onClick={ handleOpenAF }>
                                                        <ICON_NEW />
                                                        &nbsp;
                                                        <strong>AGREGAR DATOS DE IMPUTADO</strong>
                                                    </Button>
                                                    <AccusedFormModal
                                                        accuseds = { accuseds }
                                                        defensories = { defensories }
                                                        dependencies = { dependencies }
                                                        handleClose = { handleCloseAF }
                                                        minors = { minors }
                                                        selectedAccused = { selectedAccused }
                                                        setAccuseds = { setAccuseds }
                                                        show = { showAccusedForm }
                                                    />
                                                </div>                                                
                                                <div className="col-12 form-group">
                                                    {   accuseds.map( (accused,index)=>(
                                                            <AccusedInfoForm
                                                                key = { `accused${index}` }
                                                                index = { index }
                                                                accused = { accused }
                                                                handleRemove = { handleRemoveAccused }
                                                                handleEdit = { handleEditAccused }
                                                            />
                                                        ))
                                                    }    
                                                </div>                                                
                                                <div className="col-12">
                                                    <Alert variant="secondary">
                                                        <Button className="float-left" variant="light" onClick={() => handleSelect(2)}>
                                                            <ICON_PREV />
                                                            &nbsp;
                                                            <strong>PASO ANTERIOR</strong>
                                                        </Button>
                                                        <Button className="float-right" variant="light" onClick={() => handleSelect(4)}>
                                                            <strong>SIGUIENTE PASO</strong>
                                                            &nbsp;
                                                            <ICON_NEXT />
                                                        </Button>
                                                        <div className="clearfix"></div>
                                                    </Alert>
                                                </div>
                                            </div>
                                        </Tab.Pane>


                                        { /* PASO 4 */ }
                                        <Tab.Pane eventKey="p4" transition={Fade}>
                                            <div className="row my-4 mx-2">
                                                <div className="col-12">
                                                    <div className="alert alert-info">
                                                        <strong>Se deben cargar los datos de la víctima SOLAMENTE sí la misma debe participar de la audiencia.</strong>
                                                        <br/>
                                                        Si desea buscar datos de las partes del Legajo indicado, presione <ICON_SEARCH /> <strong>BUSCAR VÍCTIMAS EN LAS PARTES DEL LEGAJO</strong>. Caso contrario presione el botón <ICON_NEW /> <strong>AGREGAR DATOS DE VÍCTIMA</strong>
                                                    </div>
                                                </div>
                                                {   selectedProceeding 
                                                        ?
                                                            <div className="col-md-6 form-group">
                                                                <Button variant="info" block onClick={() => handleOpenProceedingParts('victim')}>
                                                                    <ICON_SEARCH />
                                                                    &nbsp;
                                                                    <strong>BUSCAR VÍCTIMAS EN LAS PARTES DEL LEGAJO</strong>
                                                                </Button>
                                                            </div>
                                                        : 
                                                            null
                                                }
                                                <div className="col-md-4 form-group">
                                                    <Button variant="success" block onClick={ handleOpenVF }>
                                                        <ICON_NEW />
                                                        &nbsp;
                                                        <strong>AGREGAR DATOS DE VÍCTIMA</strong>
                                                    </Button>
                                                    <VictimFormModal
                                                        defensories = { defensories }
                                                        handleClose = { handleCloseVF }
                                                        selectedVictim = { selectedVictim }
                                                        setVictims = { setVictims }
                                                        show = { showVictimForm }
                                                        victims = { victims }
                                                    />
                                                </div>                                                
                                                <div className="col-12 form-group">
                                                    {   victims.map( (victim,index)=>(
                                                            <VictimInfoForm
                                                                key = { `victim${index}` }
                                                                index = { index }
                                                                victim = { victim }
                                                                handleRemove = { handleRemoveVictim }
                                                                handleEdit = { handleEditVictim }
                                                            />
                                                        ))
                                                    }    
                                                </div>                                                
                                                <div className="col-12">
                                                    <Alert variant="secondary">
                                                        <Button className="float-left" variant="light" onClick={() => handleSelect(3)}>
                                                            <ICON_PREV />
                                                            &nbsp;
                                                            <strong>PASO ANTERIOR</strong>
                                                        </Button>
                                                        <Button className="float-right" variant="light" onClick={() => handleSelect(5)}>
                                                            <strong>SIGUIENTE PASO</strong>
                                                            &nbsp;
                                                            <ICON_NEXT />
                                                        </Button>
                                                        <div className="clearfix"></div>
                                                    </Alert>
                                                </div>
                                            </div>
                                        </Tab.Pane>


                                        { /* PASO 5 */ }
                                        <Tab.Pane eventKey="p5" transition={Fade}>
                                            <div className="row my-4 mx-2">
                                                <div className="col-12">
                                                    <div className="alert alert-info">
                                                        En esta sección podrá ingresar la información de los demás participantes de la audiencia que no se correspondan con los IMPUTADOS y las VÍCTIMAS (ej. testigos, peritos, etc). 
                                                        Para hacerlo presiones sobre el botón <strong>NUEVO</strong> <ICON_NEW /> para agregar un nuevo registro y completar los datos manualmente.
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <table className="table table-sm table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th className="align-middle text-center">Apellido/s y Nombre/s</th>
                                                                <th className="align-middle text-center">Carácter</th>
                                                                <th className="align-middle text-center">Teléfono</th>
                                                                <th className="align-middle text-center">Email</th>
                                                                <th className="align-middle text-center">Domicilio</th>
                                                                <th className="align-middle text-center" width="5%">
                                                                    <Button variant="success" size="sm" onClick={handleOpenIF}>
                                                                        <ICON_NEW />
                                                                    </Button>
                                                                    <InterveningFormModal
                                                                        show = { showInterveningForm }
                                                                        handleClose = { handleCloseIF }
                                                                        intervenings = { intervenings }
                                                                        setIntervenings = { setIntervenings }
                                                                        characters = { characters }
                                                                        isEdit = { false }
                                                                    />
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {   intervenings.map( (intervening,index)=>(
                                                                    <InterveeningInfoForm
                                                                        key = { `intervening${index}` }
                                                                        intervening = {intervening }
                                                                        handleRemove = { handleRemoveIntervening }
                                                                    />
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="col-12 form-group">
                                                    <textarea
                                                        name = "observacion"
                                                        className = "form-control"
                                                        onChange = { handleChange }
                                                        placeholder = "Ingrese aquí las observaciones"
                                                        rows = "3"
                                                    >
                                                    </textarea>
                                                </div>
                                                <div className="col-12">
                                                    <div className="alert alert-warning">
                                                        <div className="form-check">
                                                            <input
                                                                name = "dj"
                                                                type = "checkbox"
                                                                className = "form-check-input"
                                                                value = "1"
                                                                onChange = { handleChange }
                                                            />
                                                            <label className="form-check-label">
                                                                La información indicada en este formulario tiene carácter de <strong>Declaración Jurada</strong>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>                                            
                                                <div className="col-12">
                                                    <Alert variant="secondary">
                                                        <Button className="float-left" variant="light" onClick={() => handleSelect(4)}>
                                                            <ICON_PREV />
                                                            &nbsp;
                                                            <strong>PASO ANTERIOR</strong>
                                                        </Button>
                                                        <Button className="float-right" variant="success" type="submit">
                                                            <ICON_SAVE />
                                                            &nbsp;
                                                            <strong>PROCESAR / GUARDAR SOLICITUD</strong>
                                                        </Button>
                                                        <div className="clearfix"></div>
                                                    </Alert>
                                                </div>
                                            </div>
                                        </Tab.Pane>


                                    </Tab.Content>
                                </Tab.Container>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            

            <LawyerSearchForm
                show = { showLawyer }
                handleClose = { handleCloseLawyerSearch }
            />


        </React.Fragment>
    );
};

export default AudienceForm;